import { BaseCode } from '@/utils/crypt';
import pako from 'pako';

const compressData = dataContent => {
  const md5 = new BaseCode()._getmd5String(dataContent);
  const outputBinary = pako.gzip(dataContent, { to: 'string' });
  const outputBase64 = btoa(outputBinary);
  return [outputBase64, md5];
};

export { compressData };
